<template>
  <div class="theme_details">
    <!-- <div class="banner">
      <div class="w flex" style="justify-content: space-between;">
        <div class="ban_l">
          <div class="tit">{{ themeTitle }}专区</div>
          <div class="desc">{{ introduction }}</div>
        </div>
        <div class="ban_r"></div>
      </div>
    </div> -->
    <img class="banner clearfix" :src="imgPrefix+banner" alt="">
    <div class="w flex" style="justify-content: space-between;height: 17rem;">
      <div class="ban_l" style="margin-top: 0;">
        <div class="tit">{{themeTitle}}</div>
        <div class="desc"> {{introduction}}</div>
      </div>
    </div>
    <div class="w navi">
      <div class="tit">
        当前位置：<span @click="returnFn">主题专区</span>
        <img src="../../assets/icon/icon-right.png" alt="" />
        {{ themeTitle }}专区
      </div>
      <div class="flex navi_box">
        <div
          :class="[
            'navi_tit',
            index == tabIndex ? 'navi_cls' : '',
            index == 0 ? '' : 'navi_line',
          ]"
          v-for="(item, index) in conData"
          :key="index"
          @click="tabChange(item.id,index)"
        >
          {{ item.themeServiceName }}
        </div>
      </div>
    </div>
    <div class="w content flex" v-if="conNavi.listVo.length>0">
      <div class="con_l">
        <div class="con_tit">介绍</div>
        <div class="desc">{{conNavi.introduction}}</div>
                       
        <div class="con_navi">
          <div
            :class="[
              'con_navi_box',
              'flex',
              index == conIndex ? 'con_navi_click' : '',
            ]"
            v-for="(item, index) in conNavi.listVo" :key="index"
            @click="conClick(item)" @mouseover="onMouseover(index)"
          >
            <div>{{ item.serviceManageMame }}</div>
            <img
              v-if="index == conIndex"
              src="../../assets/icon/right-blue.png"
              alt=""
            />
            <img v-else src="../../assets/icon/right-black.png" alt="" />
          </div>
        </div>
      </div>
      <template v-if="conNavi.listVo.length>0">
        <div class="con_r" @click="previewFn">
          <a-icon v-if="loading" type="loading" />
          <img v-else :src="imgPrefix+conNavi.listVo[conIndex].picture" alt="" />
        </div>
    </template>

    </div>
    <!-- 常见问题 -->
    <div class="w question">
      <div class="ques_tit">常见问题</div>
      <div
        v-for="(item, idx) in questionData"
        :key="idx"
        :class="item.ask ? 'ques_con' : 'ques_list'"
      >
        <div style="margin-bottom: 16px;justify-content: space-between;" class="flex">
          <div><span class="wen">问：</span>{{ item.question }}</div>
          <div>
            <a-icon v-if="!item.checked" @click="changeCheck(idx,1)" type="down" style="cursor: pointer;"/>
            <a-icon v-else @click="changeCheck(idx,0)" type="up" style="cursor: pointer;"/>
          </div>
        </div>
        <div v-if="item.checked" style="display: flex;">
          <span class="da">答：</span >
          <div v-html="item.ask" class="da_con"></div>
        </div>
      </div>
    </div>

    <!-- 预览图片 -->
    <a-modal :width="600" :visible="previewVisible" :footer="null" @cancel="previewVisible=false">
      <img alt="example" style="width: 100%" :src="previewImage" />
    </a-modal>
  </div>
</template>
 
<script>
import imgPrefix from "../../../utils/imgPrefix";

import {findThemeByIdApi,findThemeServiceByThemeIdApi,findThemeIssuesByThemeServiceIdApi,findThemeAqByThemeIdApi} from '@/api/index'
export default {
  data() {
    return {
      loading:false,
      themeTitle:'',
      introduction:'',
      banner:'',
      imgPrefix,
      tabIndex: 0,
      conIndex: 0,
      conData: [],     
      conNavi: {listVo:[{picture:''}]},
      questionData: [],    
      themeId:'',
      previewVisible:false,
      previewImage:'',
    };
  },
  created() {
    // console.log(this.$route.query);
    // 获取专区名称简介
    let themeId = this.$route.query.themeId;
    findThemeByIdApi(themeId).then(res => {
      // console.log(res);
      this.themeTitle = res.name;
      this.introduction = res.introduction;
      this.banner = res.banner;
    }).catch(err => {
      this.$message.error(err.message)
    })
    // 获取tab栏
    findThemeServiceByThemeIdApi(themeId).then(res => {
      // console.log(res);
      this.conData = res;
      if(res.length>0){
        this.getFindThemeIssuesBy(res[0]?.id)
      }
    })
    // 获取常见问题
    findThemeAqByThemeIdApi(themeId).then(res => {
      // console.log(res);
      res.forEach(item => {
        item.checked = false;
      })
      this.questionData = res;
    })


  },
  methods: {
    // 获取tab栏下面的数据
    getFindThemeIssuesBy(id){
      findThemeIssuesByThemeServiceIdApi(id).then(res => {
        this.conNavi = res;
      }).catch(err => {
        this.$message.error(err.message);
      })
    },
    tabChange(id,idx) {
      this.tabIndex = idx;
      // this.conIndex = 0;
      this.getFindThemeIssuesBy(id);
    },
    onMouseover(idx) {
      this.conIndex = idx;
      this.loading = true;
      setTimeout(() => {
        this.loading = false;
      },400)
    },
    conClick(val){
      window.open(val.pcUrl)
    },
    changeCheck(idx,num){
      this.questionData[idx].checked = num == 1 ? true : false;
    },
    returnFn(){
      // this.$router.go(-1)
      let naviTop = JSON.parse(sessionStorage.getItem('naviArr'))
      naviTop.forEach(item=> {
        if(item.link == '/theme'){
          this.$router.push('/theme?naviId='+item.id)
        }
      });
    },
    previewFn(){
      this.previewVisible = true;
      if(this.conNavi.listVo.length>0){
        this.previewImage = this.imgPrefix+this.conNavi.listVo[this.conIndex].picture;
        console.log(this.previewImage);
      }
    },
  },
};
</script>
 
<style lang = "less" scoped>
.theme_details {
  .banner {
    width: 100%;
    height: 17rem;
    text-align: left;
    position: absolute;
    left: 0;
    object-fit: cover;
    // .ban_r {
    //   width: 43%;
    //   height: 272px;
    //   background: url("../../assets/banner-theme.png") no-repeat right;
    // }
  }
  .navi {
    text-align: left;
    margin-top: 37px;
    .tit {
      color: #7a8ba4;
      opacity: 0.8;
      margin-bottom: 2%;
      span{
        cursor: pointer;
      }
      img {
        margin: 0 4px 2px 7px;
      }
    }
    .navi_box {
      margin-bottom: 4%;
      border-bottom: 1px solid #ebeffc;
    }
    .navi_tit {
      margin: 0 40px 0 40px;
      font-size: 18px;
      cursor: pointer;
      padding-bottom: 9px;
      position: relative;
      &:first-child {
        margin-left: 0;
      }
    }
    .navi_cls {
      color: var(--themeColor);
      border-bottom: 2px solid var(--themeColor);
    }
    .navi_line::after {
      content: "";
      position: absolute;
      top: 17%;
      /* left: -35%; */
      left: -40px;
      width: 1px;
      height: 16px;
      background: #ebeffc;
      /* background: red; */
    }
  }
  .content {
    justify-content: space-between;
    align-items: normal;
    text-align: left;
    margin-bottom: 6%;
    .con_l {
      width: 40%;
      .con_tit {
        font-size: 20px;
        margin-bottom: 16px;
      }
      .desc {
        color: #7a8ba4;
      }
      .con_navi {
        margin-top: 80px;
        .con_navi_box {
          padding: 17px 20px;
          border: 1px solid #ebeffc;
          margin-bottom: 2%;
          font-size: 18px;
          justify-content: space-between;
          cursor: pointer;
        }
        .con_navi_click {
          color: var(--themeColor);
          background: #ebeffc;
        }
        .con_navi_box:hover {
          color: var(--themeColor);
          box-shadow: 0 0 8px #ddd;
        }
      }
    }
    .con_r {
      width: 55%;
      // height: 510px;
      border: 1px solid #ebeffc;
      padding: 10px 20px;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      img {
        width: 100%;
      }
    }
  }
  .question {
    text-align: left;
    margin-bottom: 10%;
    .ques_tit {
      font-size: 20px;
      width: 100%;
      padding-bottom: 11px;
      margin-bottom: 3%;
      border-bottom: 1px solid #e0e5f0;
    }
    .ques_con {
      padding: 24px;
      background: #f7f8fb;
      border-radius: 4px;
      margin-bottom: 16px;
      .da {
        color: #ff0000;
      }
      .da_con {
        color: #7a8ba4;
      }
    }
    .wen {
      color: var(--themeColor);
    }
    .ques_list {
      border: 1px solid #e0e5f0;
      border-radius: 4px;
      padding: 2%;
      margin-bottom: 16px;
    }
  }
}
/deep/.ant-modal-close-x{
  display: none;
}
/deep/.ant-modal-body{
  padding: 0;
}
</style>